<template>
  <div>
    <template v-if="!reviewDashboard() && !codingDashboard()">
      <h1 class="page-header">No Access</h1>
      You do not have access to the dashboard. Please contact HIA.
    </template>

    <template v-else>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <clientNavSelector></clientNavSelector>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/${currentClientId}/dashboard` }">Coding Review Dashboard</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="top-margin">
        <ReviewDashboard></ReviewDashboard>
      </div>
    </template>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import { mapState, mapActions, mapMutations } from 'vuex'
import ReviewDashboard from '@/views/Dashboards/ReviewDashboard'

export default {
  name: 'dashboard',
  mixins: [HiaAuthorization, money],
  data() {
    return {
      loading: false,
      initLoading: false,
      reviewLoading: false,
      dateRange: [],
      activeTab: 'coding'
    }
  },
  components: {
    ReviewDashboard
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD', 'GET_DASHBOARD_PROJECTS', 'POST_REVIEW_DASHBOARD_ALL']),
    ...mapMutations('dashboard/', ['CLEAR_REVIEW_DASHBOARD']),
    handleTabClick(tab, event) {
      // console.log(tab, event)
    },
    tabDashboardCheck(tab) {
      let flag = false
      if (this.dashboardData.length) {
        flag = !this.dashboardData.some(x => x.type === tab)
      }
      return flag
    }
  },
  created: function() {},
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'reviewDashboardData'])
  }
}
</script>

<style scoped>
.coding {
  /* background: rgba(255, 196, 12, 1) !important; */
}

.review {
  /* background: rgba(236, 0, 140, 1) !important; */
}

.profee {
  /* background: rgba(109, 207, 246, 1) !important; */
}

.learn {
  /* background: rgba(136, 185, 91, 1) !important; */
}

>>> .smallCardPadding .el-card__body {
  padding: 5px !important;
}

>>> .dataTitle {
  display: block;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #606266;
}

>>> .dataText {
  display: block;
  font-size: 30px;
  color: #606266;
  text-align: left !important;
  font-weight: 400;
  padding: 5px 0px 5px 0px;
}

>>> .dataFooter {
  display: block;
  font-size: 12px;
  color: #606266;
  text-align: left !important;
  font-weight: 400;
}

>>> .dataFooter a {
  /* color: #606266;
      font-size: 14px; */
}

>>> .dataCard {
  /* height: 65px; */
  width: 100%;
  height: 100%;
}

>>> .dataCard .el-card__header {
  /* padding: 8px 10px;
      font-size: 18px;
      font-weight: 400; */
}

>>> .dataCard .el-table {
  overflow: auto;
}

>>> .dataCard .el-card__body {
  padding: 5px;
}

>>> .dataCard .el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}

>>> .codingCard .el-card__header {
  padding: 8px 10px;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  background: rgba(255, 196, 12, 0.8);
}

>>> .reviewCard .el-card__header {
  padding: 8px 10px;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  /* background: rgba(236, 0, 140, .8); */
  background: rgba(19, 86, 149, 0.8);
}

>>> .reportCard .el-card__header {
  padding: 8px 10px;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  background: rgba(0, 86, 149, 0.8);
}

>>> .el-table .cell {
  word-break: normal;
}

#clientTitle {
  text-align: left;
  font-size: 20px;
}

#dashboardTabs {
  margin: 0px 0px 0px 0px;
}

#dashboardTabs >>> .el-tabs__nav-wrap::after {
  background-color: transparent;
}

#dashboardTabs >>> .el-tabs__content {
  overflow: inherit;
}

#codingLargeStat1 >>> .el-table__body-wrapper {
  overflow-x: inherit;
}

#codingLargeStat1 >>> .avatar {
  display: block !important;
}
</style>
